import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { SSO_CATALOGS } from "./model/sso-copy.ts";
import { SSO_ERROR_COPY } from "./model/sso-error-copy.ts";

// Single sign-on: the admin's self-serve setup under Settings, and the page
// that stands in for the company's identity provider.
// Settings → Enterprise hides behind `enterprise-settings` (S43.05, D1370).
export const ssoBrowserModule: BrowserModule = defineBrowserModule("sso")
  .withErrorCopy(SSO_ERROR_COPY)
  .withScreens({
    setup: {
      path: "/settings/sso",
      title: phrase(SSO_CATALOGS, "setupScreenTitle"),
      layout: "app",
      flag: "enterprise-settings",
      load: () => import("./ui/sections/sso-setup-screen.tsx"),
    },
    idp: {
      path: "/sso/idp/:connectionId",
      title: phrase(SSO_CATALOGS, "idpScreenTitle"),
      layout: "auth",
      load: () => import("./ui/sections/idp-screen.tsx"),
    },
  })
  .withNavigation([
    {
      id: "sso",
      group: "settings-enterprise",
      label: phrase(SSO_CATALOGS, "navSingleSignOn"),
      href: "/settings/sso",
      icon: "shield-check",
      order: 872,
      flag: "enterprise-settings",
    },
  ]);
